import { render, staticRenderFns } from "./PageTypes.vue?vue&type=template&id=7b9b4188&scoped=true"
import script from "./PageTypes.vue?vue&type=script&lang=js"
export * from "./PageTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9b4188",
  null
  
)

export default component.exports